import React, { useCallback, useContext } from 'react'
import { StoresContext } from '@App/contexts'
import './index.scss'
import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'
import { softDeleteCatalogTransfer } from '@App/api/routes/rightsholder/catalog-transfer'
import CatalogTransferListHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferList/CatalogTransferListHeader'
import CatalogTransferTable from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferList/CatalogTransferTable'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import { observer } from 'mobx-react'

const CatalogTransferList = () => {
    const { catalogTransferListStore, rightsholderStore } = useContext(StoresContext)

    const onDeletedClicked = useCallback((transfer: CatalogTransferView) => {
        if (transfer.catalogTransferStatus !== 'CREATING') {
            return
        }

        softDeleteCatalogTransfer(rightsholderStore.currentRightsholderId, transfer.id).then(() =>
            catalogTransferListStore.invalidateCatalogTransfers()
        )
    }, [])

    const catalogTransferTableTabs: Tab[] = [
        {
            tabName: 'My Submissions',
            tabDisplayName: 'My Submissions',
            tabComponent: (
                <CatalogTransferTable
                    onDeletedClicked={onDeletedClicked}
                    catalogTransferTabStore={catalogTransferListStore.catalogTransferListTabStore}
                    key="LIST"
                />
            ),
        },
        {
            tabName: 'For My Review',
            tabDisplayName: 'For My Review',
            tabComponent: (
                <CatalogTransferTable
                    isReviewTab
                    catalogTransferTabStore={catalogTransferListStore.catalogTransferReviewTabStore}
                    key="REVIEW"
                />
            ),
        },
    ]

    return (
        <div className="catalog-transfer-wrapper catalog-transfer-list-wrapper">
            <CatalogTransferListHeader />
            <div className="catalog-transfer-list">
                <TabsWrapperComponent
                    tabs={catalogTransferTableTabs}
                    defaultTab={catalogTransferTableTabs[0]}
                    preventScrollReset
                />
            </div>
        </div>
    )
}

export default observer(CatalogTransferList)
